import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { IKeyValue } from '../i2g-ng-utils.data';

export const quarters: List<IKeyValue> = List([
  {
    key: 'Q1',
    value: 1,
  },
  {
    key: 'Q2',
    value: 2,
  },
  {
    key: 'Q3',
    value: 3,
  },
  {
    key: 'Q4',
    value: 4,
  },
]);

export function quartersLocalized(
  translateService: TranslateService
): List<IKeyValue> {
  return quarters.map(
    (quarter: IKeyValue): IKeyValue => {
      return {
        key: translateService.instant(`DATE.QUARTER.${quarter.key}`),
        value: quarter.value,
      };
    }
  ) as List<IKeyValue>;
}
